// eslint-disable-next-line no-restricted-imports
import { deserialize } from "@ungap/structured-clone";

export const safeDeserialize = <T>(data: Array<unknown> | T): T => {
    try {
        if (Array.isArray(data)) {
            return deserialize(data) as T;
        }
        return data;
    } catch {
        return data as T;
    }
};
